import { AxiosInstance } from 'axios';

import { DeleteItemsInput } from '../../types';
import { Size, Sizes } from '../../types/Size';
import { sizeEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { CreateSizeInput } from './SizesApi.schema';

class SizesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (size: CreateSizeInput): Promise<Size> => {
    return this.#requestInstance.post(sizeEndpoints.size, size);
  };

  getSizes = async (): Promise<Sizes> => {
    return this.#requestInstance.get(sizeEndpoints.size);
  };

  deleteSize = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(sizeEndpoints.getSizeById(id));
  };

  deleteManySizes = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(sizeEndpoints.size, { data: input });
  };

  getSizeById = async (id: number): Promise<Size> => {
    return this.#requestInstance.get(sizeEndpoints.getSizeById(id));
  };

  updateSize = async (size: Size): Promise<Size> => {
    return this.#requestInstance.patch(sizeEndpoints.getSizeById(size.id), { name: size.name });
  };
}

export const sizesApi = new SizesApi(axios);
